import { EstatusCargaFacturasService } from '../../services/status-uploadInvoices/estatus-cargaFacturas.service';
import { GeneralService } from '../../services/admin/general.service';
import { ENPOINT } from '../../services/endpoint';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CatalogsService } from '../../services/catalogs/catalogs.service';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import {TranslateService} from '@ngx-translate/core';
import { Router, ActivatedRoute, Params, Data} from '@angular/router';

@Component({
  selector: 'app-estatusCargaFacturas',
  templateUrl: './estatus-cargaFacturas.component.html',
  styleUrls: ['./estatus-cargaFacturas.component.scss'],
  providers: [GeneralService, CatalogsService, EstatusCargaFacturasService]
})
export class EstatusCargaFacturasComponent implements OnInit {
  private language = localStorage.getItem('LOCAL_STORAGE');

  @Input() entradasMercanciaSeleccionadas;
  @Input() ordenesCompraSeleccionadas;
  @Input() cerrarModal;
  @ViewChild('myTable') table: any;
  @ViewChild('detailsTemplate') detailsTemplateRef: TemplateRef<any>;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };

  public user: User;
  private basePath;
  proveedores: CatalogsService;
  rows = [];
  closeResult: string;
  btnDescarga = false;
  flagLista = false;
  facturasCargadas;
  proveedorFilter;
  detalleFactura;
  busy: boolean = false;
  busyListado: boolean = false;
  busyPosiciones: boolean = false;
  rol;
  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();
  toastSeleccionarEntradas;
  sinDatos;
  public toasterconfig: ToasterConfig =
  new ToasterConfig({timeout: 500});

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    public catalogs: CatalogsService,
    private estatusCargaFactsService: EstatusCargaFacturasService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private _router: Router,
    private route: ActivatedRoute,
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
      this.messages.emptyMessage = text;
    });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
      this.messages.totalMessage = text;
    });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
      this.messages.selectedMessage = text;
    });

    this.translate.get('texto.toastSeleccionarEntradas').subscribe(
      text => {
      this.toastSeleccionarEntradas = text;
    });

    this.translate.get('texto.sinDatos').subscribe(
      text => {
      this.sinDatos = text;
    });

    this.getProveedores();
    this.basePath = ENPOINT.url;
  }
  
  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    
    // if (this.rol === 3) {
      this.obtenerListaFacturasCargadas();
    // }

    if (this.language) {
      this.language = this.language.replace(/["']/g, "")
    } 

  }

  noBack() {
    history.pushState(null, null, location.href);
      window.onpopstate = function () {
          history.go(1);
      };
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
    this.proveedorinput$.pipe(
      debounceTime(200),
      distinctUntilChanged(),

      tap(() => this.proveedoresLoading = true),
      switchMap(term =>
        this.catalogs.obtenerProveedoresBusqueda(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.proveedoresLoading = false)
    ))
    )
  );
  }

  toggleExpandRow(row) {
    // console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  changeProveedor() {
   
    if (this.proveedorFilter !== null) {
      this.obtenerListaFacturasCargadas();
    } else {
      this.facturasCargadas = [];
      this.reset();
    }

  }

  reset () {
    this.detalleFactura = null;
      this.btnDescarga = false;
      this.rows = [];
  }

  obtenerListaFacturasCargadas() {
    this.reset();
    this.busyListado = true;

    let proveedor = this.user.id;
    

    this.estatusCargaFactsService.obtenerFacturasCargadas(proveedor).subscribe(
      data => {

        this.busyListado = false;
        let response = data.facturaBatch;
        if (response.length > 0) {
          this.facturasCargadas = response;
          this.flagLista = false;
        } else {
          this.flagLista = true;
          //this.toasterService.pop('error', '', this.sinDatos);
        }


      },
      err => {
        this.busyListado = false;
        
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', '', err.error.message);
        }

      },
    );

  }

  facturaSeleccionada(factura) {
    let detalle = factura;

    if (detalle) {
      this.detalleFactura = detalle;
      this.rows = detalle.detalle;      
      this.btnDescarga = true;
    } else {
      this.reset();
    }

  }

  getArchivoZip() {
    let url = this.detalleFactura.url

    const win = window.open('data:application/zip,' + url, '_blank');
          if (win) {
            win.focus();
          } else {
            alert('Por favor activa los popups en tu navegador');
          }
  }
 
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
 
  getTraslatedText(value) {  
    if (this.language === "en") {
      switch (value) {
        case "EN PROCESO":
          return "IN PROCESS"
        case "ANULADA":
          return "CANCELED" 
        case "CREADA":
          return "CREATED"  
        case "CONFIRMADA":
          return "CONFIRMED"
        case "TERMINADO CON ERROR":
          return "FINISHED WITH ERROR"
        case "PROCESADO":
          return "PROCESSED"
        case "PROCESADA":
          return "PROCESSED"
        case "PROCESADOS":
          return "PROCESSED"
        case "TERMINADO":
          return "FINISHED"
        default: 
          break;
      }
    }
  }
 
 
 

}



// WEBPACK FOOTER //
// ./src/app/pages/status-uploadedInvoices/estatus-cargaFacturas.component.ts